import React from "react" // useRef, useEffect // useState,
import { StaticImage } from "gatsby-plugin-image"
import {
  // Container,
  Navbar,
  Nav,
  NavDropdown,
  // Form,
  // FormControl,
  // Button,
  // Fade,
} from "react-bootstrap"
import { Link } from "gatsby"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFilePdf } from "@fortawesome/free-solid-svg-icons"

const Navi = () => {
  const navDropdownMenu = (
    <button className="menu bg-transparent h-100 border-0">
      <i className="uil uil-bars text-white"></i>
      <span className="d-block text-white fw-bold">Menu</span>
    </button>
  )
  const navDropdownImport = (
    <div className="text-white d-flex justify-content-center align-items-center text-decoration-none">
      <i className="uil uil-import"></i>
    </div>
  )
  // const navDropdownShare = (
  //   <div className="text-white d-flex justify-content-center align-items-center text-decoration-none">
  //     <i className="uil uil-share-alt"></i>
  //   </div>
  // )
  // const navDropdownSearch = (
  //   <div className="text-white d-flex justify-content-center align-items-center text-decoration-none">
  //     <i className="bx bx-search"></i>
  //   </div>
  // )
  // const navDropdownGlobe = (
  //   <div className="text-white d-flex justify-content-center align-items-center text-decoration-none">
  //     <i className="bx bx-globe"></i>
  //   </div>
  // )

  // const [open, setOpen] = useState(false)
  return (
    <div className="nav2">
      <Navbar className="navbar py-0 fixed-top">
        <div className="navbar__wrapper d-flex align-items-center justify-content-between position-relative h-100">
          <div className="logo-box d-flex h-100 align-items-center hamburger">
            <NavDropdown
              title={navDropdownMenu}
              id="basic-nav-dropdown"
              className="text-white d-flex justify-content-center align-items-center text-decoration-none"
            >
              <Nav.Link target="_blank" href="/">Home</Nav.Link>
              {/* <NavDropdown title="About" id="basic-nav-dropdown" drop="end">
                <ul>
                  <li>
                    <Link to="/about/authors">Authors </Link>
                  </li>
                  <li>
                    <Link to="/about/background">Background </Link>
                  </li>
                  <li>
                    <Link to="/about/frequently-asked-questions">
                      Frequently Asked Questions
                    </Link>
                  </li>
                  <li>
                    <Link to="/about/factsheets">Fact Sheets </Link>
                  </li>
                  <li>
                    <Link to="/about/how-to-cite-this-report">
                      How to cite this report
                    </Link>
                  </li>
                </ul>
              </NavDropdown> */}
              <NavDropdown title="Resources" id="basic-nav-dropdown" drop="end">
                <ul>
                  <li>
                    <Link to="/resources/press">Press </Link>
                  </li>
                  {/* <li>
                    <Link to="/resources/presentations-and-multimedia">
                      Presentations and multimedia
                    </Link>
                  </li> */}
                  <li>
                    <Link to="/resources/spm-headline-statements">
                      SPM Headline Statements
                    </Link>
                  </li>
                  <li>
                    <Link to="/figures/">
                      Figures{" "}
                    </Link>
                  </li>
                  <li>
                    <Link to="/resources/translations/">
                      Translations{" "}
                    </Link>
                  </li>
                  <li>
                    <Link to="/resources/how-to-cite-this-report">
                      How to cite this report
                    </Link>
                  </li>
                </ul>
              </NavDropdown>
              <NavDropdown
                title="Download"
                id="basic-nav-dropdown"
                drop="end"
              // className="justify-content-center align-items-center text-decoration-none icon-download"
              >
                <div className="download-boks">
                  <Nav.Link
                    href="https://www.ipcc.ch/report/ar6/syr/downloads/report/IPCC_AR6_SYR_SPM.pdf">
                    <FontAwesomeIcon icon={faFilePdf} style={{ color: "#fff" }} />
                    Summary for Policymakers
                  </Nav.Link>
                  <Nav.Link
                    href="https://www.ipcc.ch/report/ar6/syr/downloads/report/IPCC_AR6_SYR_LongerReport.pdf">
                    <FontAwesomeIcon icon={faFilePdf} style={{ color: "#fff" }} />
                    Longer Report
                  </Nav.Link>
                  <Nav.Link
                    href="https://www.ipcc.ch/report/ar6/syr/downloads/report/IPCC_AR6_SYR_FullVolume.pdf">
                    <FontAwesomeIcon icon={faFilePdf} style={{ color: "#fff" }} />
                    SYR (Full volume)
                  </Nav.Link>
                  <Nav.Link
                    href="https://www.ipcc.ch/report/ar6/syr/downloads/report/IPCC_AR6_SYR_AnnexesIndex.pdf">
                    <FontAwesomeIcon icon={faFilePdf} style={{ color: "#fff" }} />
                    Annexes and Index
                  </Nav.Link>
                  <Nav.Link
                    href="https://www.ipcc.ch/report/ar6/syr/downloads/report/IPCC_AR6_SYR_Errata.pdf">
                    <FontAwesomeIcon icon={faFilePdf} style={{ color: "#fff" }} />
                    Errata
                  </Nav.Link>

                  {/* <div className="d-flex flex-column flex-md-row mt-4 align-items-center justify-content-center gap-4">
                      <Link to="/downloads" className="nav-download-button">
                        <button className="btn-ipcc btn btn-primary">
                          All downloads
                        </button>
                      </Link>
                    </div> */}
                </div>
              </NavDropdown>
              <NavDropdown title="Read online" id="basic-nav-dropdown" drop="end">
                <ul>
                  <li>
                    <Link to="/summary-for-policymakers">Summary for Policymakers </Link>
                  </li>
                  <li>
                    <Link to="/longer-report">
                      Longer report
                    </Link>
                  </li>
                  <li>
                    <Link to="/annexes-and-index/">
                      Annexes and Index
                    </Link>
                  </li>
                </ul>
              </NavDropdown>
            </NavDropdown>
            <Link
              to="/"
              className="logo fw-bold text-white flex-column align-items-start text-decoration-none"
            >
              AR6 Synthesis Report
            </Link>
          </div>

          <div className=" h-100 d-flex list-top">
            {/* <NavDropdown
              title="About"
              id="basic-nav-dropdown"
              drop="end"
              className="text-white d-flex justify-content-center align-items-center text-decoration-none nav-item dropdown t-link"
            >
              <ul>
                <li>
                  <Link to="/about/authors">Authors </Link>
                </li>
                <li>
                  <Link to="/about/background">Background </Link>
                </li>
                <li>
                  <Link to="/about/frequently-asked-questions">
                    Frequently Asked Questions
                  </Link>
                </li>
                <li>
                  <Link to="/about/factsheets">Fact Sheets </Link>
                </li>
                <li>
                  <Link to="/about/how-to-cite-this-report">
                    How to cite this report
                  </Link>
                </li>
              </ul>
            </NavDropdown> */}
            <NavDropdown
              title="Resources"
              id="basic-nav-dropdown"
              drop="end"
              className="text-white d-flex justify-content-center align-items-center text-decoration-none nav-item dropdown t-link"
            >
              <ul>
                <li>
                  <Link to="/resources/press">Press </Link>
                </li>
                {/* <li>
                  <Link to="/resources/presentations-and-multimedia">
                    Presentations and multimedia
                  </Link>
                </li> */}
                <li>
                  <Link to="/resources/spm-headline-statements">
                    SPM Headline Statements
                  </Link>
                </li>
                <li>
                  <Link to="/figures">
                    Figures
                  </Link>
                </li>
                <li>
                  <Link to="/resources/translations/">
                    Translations{" "}
                  </Link>
                </li>
                <li>
                  <Link to="/resources/how-to-cite-this-report">
                    How to cite this report
                  </Link>
                </li>
              </ul>
            </NavDropdown>
            <NavDropdown
              title="Download"
              id="basic-nav-dropdown"
              drop="end"
              className="text-white d-flex justify-content-center align-items-center text-decoration-none t-link"
            >
              <div className="download-boks">
                <Nav.Link
                  href="https://www.ipcc.ch/report/ar6/syr/downloads/report/IPCC_AR6_SYR_SPM.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FontAwesomeIcon icon={faFilePdf} style={{ color: "#fff" }} />
                  Summary for Policymakers
                </Nav.Link>
                <Nav.Link
                  href="https://www.ipcc.ch/report/ar6/syr/downloads/report/IPCC_AR6_SYR_LongerReport.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FontAwesomeIcon icon={faFilePdf} style={{ color: "#fff" }} />
                  Longer Report
                </Nav.Link>
                <Nav.Link
                  href="https://www.ipcc.ch/report/ar6/syr/downloads/report/IPCC_AR6_SYR_FullVolume.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FontAwesomeIcon icon={faFilePdf} style={{ color: "#fff" }} />
                  SYR (Full volume)
                </Nav.Link>
                <Nav.Link
                  href="https://www.ipcc.ch/report/ar6/syr/downloads/report/IPCC_AR6_SYR_AnnexesIndex.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FontAwesomeIcon icon={faFilePdf} style={{ color: "#fff" }} />
                  Annexes and Index
                </Nav.Link>
                <Nav.Link
                  href="https://www.ipcc.ch/report/ar6/syr/downloads/report/IPCC_AR6_SYR_Errata.pdf">
                  <FontAwesomeIcon icon={faFilePdf} style={{ color: "#fff" }} />
                  Errata
                </Nav.Link>
                {/* <div className="d-flex flex-column flex-md-row align-items-center mt-1 justify-content-center gap-4">
                  <Link to="/downloads" className="nav-dl-link">
                    <button className="btn-ipcc btn btn-primary">
                      All downloads
                    </button>
                  </Link>
                </div> */}
              </div>
            </NavDropdown>
            <NavDropdown
              title={navDropdownImport}
              id="basic-nav-dropdown"
              className="text-white d-flex justify-content-center align-items-center text-decoration-none icon-download"
            >
              <div className="download-boks">
                <h3 className="text-white dropdown-header">Download</h3>
                <Nav.Link
                  href="https://www.ipcc.ch/report/ar6/syr/downloads/report/IPCC_AR6_SYR_SPM.pdf">
                  <FontAwesomeIcon icon={faFilePdf} style={{ color: "#fff" }} />
                  Summary for Policymakers
                </Nav.Link>
                <Nav.Link
                  href="https://www.ipcc.ch/report/ar6/syr/downloads/report/IPCC_AR6_SYR_LongerReport.pdf">
                  <FontAwesomeIcon icon={faFilePdf} style={{ color: "#fff" }} />
                  Longer Report
                </Nav.Link>
                <Nav.Link
                  href="https://www.ipcc.ch/report/ar6/syr/downloads/report/IPCC_AR6_SYR_FullVolume.pdf">
                  <FontAwesomeIcon icon={faFilePdf} style={{ color: "#fff" }} />
                  SYR (Full volume)
                </Nav.Link>
                {/* <div className="d-flex flex-column flex-md-row mt-4 align-items-center justify-content-center gap-4">
                  <Link to="/downloads" className="nav-download-button">
                    <button className="btn-ipcc btn btn-primary">
                      All downloads
                    </button>
                  </Link>
                </div> */}
              </div>
            </NavDropdown>
            <NavDropdown
              title="Read online"
              id="basic-nav-dropdown"
              drop="end"
              className="text-white d-flex justify-content-center align-items-center text-decoration-none nav-item dropdown t-link"
            >
              <ul>
                <li>
                  <Link to="/summary-for-policymakers">Summary for Policymakers </Link>
                </li>
                <li>
                  <Link to="/longer-report">
                    Longer report
                  </Link>
                </li>
                <li>
                  <Link to="/annexes-and-index/">
                    Annexes and Index
                  </Link>
                </li>
              </ul>
            </NavDropdown>
            <div className="logo-box d-flex h-100 align-items-center gap-5">
              <a
                id="nav-primary-logo"
                class="ipcc-logo-svg"
                href="https://www.ipcc.ch"
              >
                <svg version="1.1" x="0px" y="0px" viewBox="0 0 82 50">
                  <path
                    d="M7.8,4.6C7.8,6.4,6.2,8,4.4,8C2.5,8,1,6.4,1,4.6c0-1.9,1.5-3.4,3.4-3.4C6.2,1.2,7.8,2.7,7.8,4.6z M1.6,42.7h5.6V10.7H1.6
V42.7z M29.3,13c2,1.8,2.9,4.1,2.9,7.2v13.4c0,3.1-1,5.5-2.9,7.2c-2,1.8-4,2.7-6.3,2.7c-2,0-3.7-0.5-5-1.5v6.8h-5.6V20.2
c0-3.1,1-5.5,2.9-7.2c2-1.8,4.3-2.7,7-2.7C25,10.2,27.4,11.1,29.3,13z M26.7,20.2c0-3.7-1.9-5.3-4.3-5.3c-2.4,0-4.3,1.6-4.3,5.3
v13.4c0,3.7,1.9,5.2,4.3,5.2c2.4,0,4.3-1.7,4.3-5.3V20.2z M46.8,10.2c-2.7,0-5,0.9-7,2.7c-2,1.8-2.9,4.1-2.9,7.2v13.4
c0,3.1,1,5.5,2.9,7.2c2,1.8,4.3,2.7,7,2.7c2.7,0,5-0.9,7-2.7c2-1.8,2.9-4.1,2.9-7.2v-3.2h-5.6v3.2c0,3.6-1.9,5.3-4.3,5.3
c-2.4,0-4.3-1.6-4.3-5.2V20.2c0-3.7,1.9-5.3,4.3-5.3c2.4,0,4.3,1.6,4.3,5.3v0.6h5.6v-0.6c0-3.1-1-5.5-2.9-7.2
C51.8,11.1,49.5,10.2,46.8,10.2z M81,20.8v-0.6c0-3.1-1-5.5-2.9-7.2c-2-1.8-4.3-2.7-7-2.7c-2.7,0-5,0.9-7,2.7
c-2,1.8-2.9,4.1-2.9,7.2v13.4c0,3.1,1,5.5,2.9,7.2c2,1.8,4.3,2.7,7,2.7c2.7,0,5-0.9,7-2.7c2-1.8,2.9-4.1,2.9-7.2v-3.2h-5.6v3.2
c0,3.6-1.9,5.3-4.3,5.3c-2.4,0-4.3-1.6-4.3-5.2V20.2c0-3.7,1.9-5.3,4.3-5.3c2.4,0,4.3,1.6,4.3,5.3v0.6H81z"
                  ></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </Navbar>
    </div>
  )
}
export default Navi
